import PackRegionNode from "./PackRegionNode";

function packLargeRegions(
  items,
  floors,
  margin,
  allowHidden = true,
  maxAllowedSize = 10000000000,
  minFloor = -50000,
  padding = 0
) {
  const px = Math.abs(margin) || 0;
  let shouldKeepOn = true;
  let i = 0;

  function addLevel(lv) {
    if (lv < floors.length && floors[lv]) return;
    const newRoot = new PackRegionNode(-px, 5000000000, padding);
    floors.push(newRoot);
  }

  if (floors?.length === 0) {
    addLevel(0);
  }

  for (let x = 0; x < items.length; x++) {
    shouldKeepOn = true;
    i = 0;
    const item = items[x];
    if (allowHidden && item.hidden) {
      item.level = -500000;
      continue;
    }

    if (item.region.size > maxAllowedSize) {
      item.level = minFloor;
      continue;
    }

    while (shouldKeepOn) {
      if (floors[i].insert(item.region.g0, item.region.g1)) {
        shouldKeepOn = false;
        item.level = i;
      } else {
        addLevel((i += 1));
      }
    }
  }

  return floors;
}

export default packLargeRegions;
